var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved.
 */
import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'reactstrap';
import { IconButton } from '../common';
import { useShareableLink } from '../storeduivalue';
export var ShareLinkButton = function (props) {
    var btnRef = useRef(null);
    var _a = useState(false), isOpenNotify = _a[0], setIsOpenNotify = _a[1];
    var _b = useShareableLink(), shareableLinkData = _b[0], fetchShareableLinkData = _b[1], clearShareableLinkData = _b[2];
    var isUnmounted = useRef(false);
    useEffect(function () {
        isUnmounted.current = false;
        return function () {
            isUnmounted.current = true;
        };
    }, []);
    useEffect(function () {
        if (isOpenNotify) {
            var handler_1 = setTimeout(setIsOpenNotify, 3000, false);
            return function () { return clearTimeout(handler_1); };
        }
    }, [isOpenNotify]);
    useEffect(function () {
        var createClipboardLink = function (url) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, navigator.clipboard.writeText(url)];
                    case 1:
                        _a.sent();
                        if (!isUnmounted.current) {
                            setIsOpenNotify(true);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (shareableLinkData.data) {
            createClipboardLink(shareableLinkData.data);
            return clearShareableLinkData;
        }
    }, [clearShareableLinkData, shareableLinkData.data]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: btnRef },
            React.createElement(IconButton, { loading: shareableLinkData.requesting, icon: "link", size: "2x", onClick: fetchShareableLinkData, title: "Copy link of current view to clipboard" })),
        btnRef.current && (React.createElement(Tooltip, { isOpen: isOpenNotify, target: btnRef.current, placement: "bottom-start", hideArrow: true }, "A link to this view was copied to your clipboard."))));
};
